module.exports = __webpack_public_path__ + "img/docx.c33a66f3.svg";